<template>
  <div class="w w1200" v-loading="loading">
    <template v-if="merchantList.length">
      <div class="cart" ref="cart">
        <div class="cart-row cart-header">
          <div class="cart-col checkbox">
            <el-checkbox v-model="checkAll" @change="checkAllChange">全选</el-checkbox>
          </div>
          <div class="cart-col good-name">商品</div>
          <div class="cart-col good-price">单价</div>
          <div class="cart-col good-count">数量</div>
          <div class="cart-col good-total">小计</div>
          <div class="cart-col good-operation">操作</div>
        </div>
        <div class="cart-store" v-for="merchant in merchantList" :key="merchant.id">
          <div class="cart-store-header">
            <el-checkbox v-model="merchant.checked" @change="checkAllStoreGoods(merchant)">
              <span>{{merchant.name}}</span>
              <span class="badge" v-if="merchant.isSelfEmployed === 1">自营</span>
            </el-checkbox>
          </div>
          <div class="cart-row" v-for="good in merchant.goods" :key="good.scid">
            <template v-if="good.cartSpecificationDetails">
              <div class="cart-col checkbox"><el-checkbox v-model="good.checked" @change="checkGood"></el-checkbox></div>
              <div class="cart-col good-name">
                <div class="good-info clearfix"  @click="$tools.showGoodInBlank(good.id)">
                  <el-image class="good-img" :src="good.photos"></el-image>
                  <div class="good-info-name">{{good.name}}</div>
                  <div class="good-attr">{{good.cartSpecificationDetails.attributeContent || '默认规格'}}</div>
                </div>
              </div>
              <div class="cart-col good-price">￥{{ good.cartSpecificationDetails.price | decimal }}</div>
              <div class="cart-col good-count">
                <el-input-number size="mini" :min="1" :max="good.cartSpecificationDetails.stock + 1" v-model="good.number" @change="(nv, ov) => numberChange(nv, ov, good)"></el-input-number>
                <div class="good-stock">库存：{{good.cartSpecificationDetails.stock - good.number + 1}}件</div>
              </div>
              <div class="cart-col good-total">￥{{ (good.cartSpecificationDetails.price * good.number) | decimal }}</div>
              <div class="cart-col good-operation">
                <el-link type="danger" @click="onDelete(good)">删除</el-link>
              </div>
            </template>
          </div>
        </div>
      </div>
      <div class="bottomCount clearfix" :class="{'isFixed': bottomBarFixed}" ref="bottomBar">
      <div class="bottomCount-inner">
        <router-link tag="div" class="item goShopping" to="/goodsList">继续购物</router-link>
        <div class="bottomCount-right">
          <div class="item">
            共<strong>{{ allGoods.length }}</strong> 件商品，已选择<strong>{{ totalData.count }}</strong> 件
          </div>
          <div class="item">
            合计(不含运费):<strong class="total">{{ totalData.price | decimal }}</strong>元
          </div>
          <div class="item">
            <el-button type="danger" @click="submitForm" :disabled="totalData.count <= 0">去结算</el-button>
          </div>
        </div>
      </div>
    </div>
    </template>
    <empty v-else>购物车空空如也</empty>
  </div>
</template>

<script>
import {shoppingCartDelete, addShoppingCart} from "@/api/xunyou";
export default {
  name: "shoppingCart",
  data() {
    return {
      disBottom: 0,
      loading: false,
      checkAll: false,
      timer: null
    };
  },
  computed: {
    userInfo () {
      return this.$store.state.userInfo;
    },
    ruleFormDom () {
      return this.$refs.cart;
    },
    clientHeight () {
      return document.documentElement.clientHeight || document.body.clientHeight;
    },
    bottomBarFixed () {
      return this.disBottom + 100 - this.clientHeight >= 0;
    },
    merchantList () {
      const list = [];
      this.$store.state.carts.forEach(item => {
        if (item.bxunyouMerchant) {
          list.push(item.bxunyouMerchant);
        }
      });
      return list;
    },
    allGoods () {
      const list = [];
      this.merchantList.forEach(merchant => {
        list.push(...merchant.goods);
      });
      return list;
    },
    totalData () {
      let count = 0;
      let price = 0;
      this.allGoods.forEach(good => {
        if (good.checked) {
          count++;
          price += good.cartSpecificationDetails.price * good.number;
        }
      });
      return {count, price};
    }
  },
  mounted() {
    this.$store.dispatch('getCartList');
    this.initScroll();
  },
  beforeDestroy() {
     window.removeEventListener('scroll', this.handleScroller,true);
  },
  methods: {
    // 改变购物车商品数量
    numberChange(nv, ov, good) {
      this.doChange(nv, ov, good);
    },
    doChange (nv, ov, good) {
      if (nv > good.cartSpecificationDetails.stock) {
        this.$message.warning('库存不足！')
        return ;
      }
      this.$tools.isLogin(() => {
        if (good.status !== 1 || good.approvalStatus !== 1) {
          this.$message.error('暂时缺货');
          return ;
        }
        addShoppingCart({
          cid: good.id,
          uid: this.$store.getters.userId,
          updType: 'OFFSET',
          number: nv - ov,
          bxysid: good.cartSpecificationDetails.id
        }).then((res) => {
          console.log('新增购物车结果：', res);
        }).catch((err) => {
          this.$message.error("添加购物车失败，请稍后再试！");
        });
      });
    },
    // 全选切换
    checkAllChange (e) {
      this.merchantList.forEach(merchant => {
        merchant.checked = this.checkAll;
        if (merchant.goods && merchant.goods.length) {
          merchant.goods.forEach(good => {
            good.checked = merchant.checked;
          });
        }
      });
    },
    // 全选店铺下所有商品
    checkAllStoreGoods (merchant) {
      if (merchant.goods && merchant.goods.length) {
        merchant.goods.forEach(good => {
          good.checked = merchant.checked;
        });
        this.checkAllByMerchant();
      }
    },
    // 商品勾选
    checkGood () {
      this.checkStoreByGoods();
      this.checkAllByMerchant();
    },
    // 判断是否商品全选，勾选相关父级全选
    checkStoreByGoods () {
      this.merchantList.forEach(merchant => {
        merchant.checked = merchant.goods.every(good => good.checked);
      });
    },
    // 根据店铺选中情况判断是否全选
    checkAllByMerchant () {
      this.checkAll = this.merchantList.every(merchant => merchant.checked);
    },

    initScroll () {
      if (this.disBottom === 0) {
        this.$nextTick(() => {
          this.handleScroller();
        });
      }
      window.addEventListener('scroll', this.handleScroller, true);
    },
    handleScroller () {
      if (this.ruleFormDom) {
        this.disBottom = this.ruleFormDom.getBoundingClientRect().bottom;
      }
    },
    // 删除
    onDelete(good) {
      this.$confirm(`确定将商品【${good.name}】从购物车中移除？`, '移除商品', {
        confirmButtonText: '删除',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loading = true;
        shoppingCartDelete({ ids: good.scid }).then((res) => {
          console.log(res)
          this.loading = false;
          if(res.code === 0){
            this.$store.dispatch('getCartList')
            this.$message.success("已移除！");
          }
        }).catch((err) => {
          this.loading = false;
          this.$message.error("删除失败，请稍后再试！");
        });
      });
    },
    // 提交
    submitForm() {
      const res = [];
      this.merchantList.forEach( merchant => {
        const temp = [];
        merchant.goods.forEach(good => {
          if (good.checked) temp.push({
            scid: good.scid,
            number: good.number,
            name: good.name,
            skuId: good.cartSpecificationDetails.id
          });
        });
        if (temp.length) {
          res.push({
            ...merchant,
            goods: temp
          });
        }
      });
      if (res.length) {
        const flagSet = new Set();
        res.forEach(mer => {
          flagSet.add(mer.isSelfEmployed);
        })
        if (flagSet.size > 1) {
          this.$message.error('自营商品与普通商品无法合并下单，请将自营商品与普通商品分开下单');
          return false;
        }
        this.$store.commit('SAVE_SELECTED_GOODS', res);
        this.$router.push('/orderDetail');
      }
    }
  }
};
</script>
<style scoped lang='less'>
.cart-row{
  display: table;
  width: 100%;
  .cart-col{
    display: table-cell;
    padding: 10px;
  }
}
.cart{
  margin-top: 20px;
  .cart-header{
    background-color: #e9e9e9;
  }
  .checkbox{
    width: 70px;
    /deep/ .el-checkbox__label{
      font-size: 12px;
    }
  }
  .good-price, .good-count, .good-total, .good-operation{
    width: 130px;
  }
  .good-stock{
    color: #999999;
    text-align: center;
  }
  .cart-store{
    margin-bottom: 15px;
    background-color: #fff;
    .cart-store-header{
      padding: 10px;
      border-bottom: 1px solid #ffb7b7;
      font-weight: 500;
      font-size: 14px;
    }
    .badge{
      background: var(--main-theme-color);
      font-size: 12px;
      padding: 0 6px;
      border-radius: 3px;
      color: #fff;
      margin-left: 5px;
    }
  }

  .good-info{
    cursor: pointer;
    &:hover .good-info-name{
      color: var(--main-theme-color);
    }
    .good-img{
      float: left;
      width: 70px;
      height: 70px;
      background-color: #F5F5F5;
      border-radius: 10px;
      border: 1px solid #F5F5F5;
    }
    .good-info-name{
      height: 36px;
      color: #333333;
      font-weight: 500;
      padding-left: 80px;
      margin-bottom: 5px;
    }
    .good-attr{
      display: inline-block;
      padding: 0 10px;
      font-size: 12px;
      background-color: rgba(255, 84, 0, 0.2);
      border-radius: 3px;
      margin-left: 10px;
    }
  }
}
.bottomCount {
  transition: all 0.3s ease-in;
  background-color: #fff;
  &.isFixed {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 1;
    /deep/ .bottomCount-inner{
      width: 1200px;
      margin: 0 auto;
    }
  }
  .bottomCount-right{
    float: right;
    display: inline-block;
    text-align: right;
    /deep/ .el-button{
      padding: 12px 40px;
    }
  }
  .item{
    display: inline-block;
    padding: 10px;
    color: var(--main-theme-color);
    &.goShopping{
      padding: 20px;
      cursor: pointer;
    }
    .total{
      font-size: 1.8em;
    }
  }

  .countedSize {
    width: 100%;
  }
  .totalNum {
    color: var(--main-theme-color);
    .totalSize {
      font-size: 30px;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/views/shoppingcart/shoppingcart.vue